import { usePrestudyContext } from "../../context/Prestudy/PrestudyContextProvider";
import { Divider, Flex, Grid, GridItem, Spacer, Text } from "@chakra-ui/layout";
import { SPACING } from "../../constants/Constants";
import { PerParticipantTokensAndActivity } from "../../utility-functions/PrestudyUtils";
import { Card } from "@chakra-ui/card";
import { English } from "../../Texts";
import DoubleDivider from "../DoubleDivider";

export default function ParticipantTimeCard({ perParticipantTokens }: { perParticipantTokens: PerParticipantTokensAndActivity[] }) {
    const texts = English.prestudySplitter;
    return (
        <Grid
            templateColumns='repeat(4, 3fr)'
            gap={SPACING}
            w={"75vw"}
        >
            {perParticipantTokens.map((participant, index) => (
                <GridItem colSpan={1} key={index} display={"flex"}>
                    <Card variant={"outline"} p={SPACING / 2} flexGrow={1}>
                        <Flex>
                            <Text fontWeight={"bold"}>{texts.labels.participant}</Text>
                            <Spacer />
                            {participant.participant}
                        </Flex>
                        <DoubleDivider my={SPACING / 4} />
                        {participant.activityTokens.map((activityToken, index) => (
                            <>
                                <Flex key={index}>
                                    <Text mr={SPACING / 2} fontWeight={"bold"}>{texts.labels.activityNumberShort}</Text>
                                    <Text>{activityToken.activity}</Text>
                                    <Spacer />
                                    <Text>{activityToken.tokens * 30} {texts.labels.minutesShort}</Text>
                                </Flex>
                                <Divider />
                            </>
                        ))}

                    </Card>
                </GridItem>
            ))}
        </Grid>
    );
}